import CallDealerModal from '../src/components/CallDealerModal/CallDealerModal.tsx';

export default CallDealerModal;
